export const activityEditFields = Object.freeze({
  name: {
    index: 0,
    label: 'Activity Title'
  },
  goals: {
    index: 1,
    label: 'Activity Goals'
  },
  description: {
    index: 2,
    label: 'Activity Description'
  },
  checkpoint: {
    index: 3,
    label: 'Check-In?'
  },
  work_product: {
    index: 4,
    label: 'Requires Artifact?'
  },
  artifact_type_id: {
    index: 5,
    label: 'Artifact Type'
  },
  artifact_description: {
    index: 6,
    label: 'Artifact Description'
  },
  inline_notes: {
    index: 7,
    label: 'Notes for Mentors'
  },
  mentor_assessment_questions: {
    index: 8,
    label: 'Assessment Questions for Mentors'
  }
})



// WEBPACK FOOTER //
// ./src/constants/activity.js